import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-details',
  templateUrl: './features-details.component.html',
  styleUrls: ['./features-details.component.css']
})
export class FeaturesDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
